<rt-wysiwyg-inline-button
  cdk-overlay-origin
  #trigger="cdkOverlayOrigin"
  [clipboardValue]="state.active.id"
  [displayValue]="state.activeIdWithoutBrackets"
  [rtTooltip]="state.tooltipMessage"
  [active]="dropdownOpen"
  [status]="state.active.data.status!"
  (click)="toggleDropdown()"
></rt-wysiwyg-inline-button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="dropdownOpen"
  [cdkConnectedOverlayWidth]="300"
  (backdropClick)="toggleDropdown()"
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayPush="true"
>
  <rt-wysiwyg-placeholder-dropdown
    [placeholders]="state.placeholders"
    [active]="state.active"
    (action)="emit($event); toggleDropdown()"
  ></rt-wysiwyg-placeholder-dropdown>
</ng-template>
